import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Badge, Typography } from 'antd';

import ConfigTableColumns from '../../components/Documents/ConfigTableColumns/ConfigTableColumns';
import TopPanel from '../../components/Documents/TopPanel/TopPanel';
import FiltersInfoPanel from '../../components/Documents/FiltersInfoPanel/FiltersInfoPanel';
import Filters from '../../components/Documents/Filters/Filters';
import PlacemarkMap from '../../../../Executorship/common/PlacemarkMap/PlacemarkMap';
import OrdersTable from '../../../../Executorship/Order/components/Orders/Table/Table';

import * as documentsActions from '../../redux/actions/documents';
import * as filtersActions from '../../redux/actions/filters';

import './Documents.css';
import { getNumberWithoutSpaces } from '../../../../../common/utils/format';
import * as URLs from '../../../../../common/constants/systemUrls';

const { Text } = Typography;

const { getAllOrdersForDocuments } = documentsActions;
const {
  updateFilterFieldsOrdersForDocuments,
  changeTypeListDocuments,
  searchOrdersForDocuments,
  resetFiltersOrdersForDocuments,
} = filtersActions;

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMap: false,
      isDrawerVisible: false,
      drawerCols: {
        info: true,
        view: true,
        state: true,
        passengers: true,
        documents: true,
        price: true,
        routeLength: false,
        dateApplication: true,
        placeDelivery: false,
        settlementForm: false,
        driver: false,
        finalDestination: false,
        dateCreation: false,
        statusSendingACBDPL: false,
        sendingTrafficPolice: false,
      },
      tableColumnsLen: 0,
      showFilterAll: false,
      pagination: {
        pages: 3,
      },
      visibleSuccessSaveFilter: false,
      visibleAcceptSaveFilter: false,
      orders: [],
      markers: [],
    };
    this.state.tableColumnsLen = this.getTableColumnsLen();
  }

  componentDidMount() {
    this.updateData();
    this.props.getAllOrdersForDocuments();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.orders !== this.props.orders ||
      prevProps.filters !== this.props.filters
    ) {
      this.updateData();
    }
  }

  updateData = () => {
    if (this.props.orders) {
      const orders =
        this.props.filters.typeList && this.props.filters.typeList !== 'all'
          ? this.props.orders.filter(
              item =>
                item.state &&
                item.state.statusKeyGroup === this.props.filters.typeList
            )
          : this.props.orders;

      let markers = [];
      orders.forEach(item => {
        if (item.map) {
          markers.push(item.map);
        }
      });
      this.setState({
        orders,
        markers,
      });
    }
  };

  toggleAllFilter = () => {
    this.setState(() => ({
      showFilterAll: !this.state.showFilterAll,
    }));
  };

  resetFilters = () => {
    this.props.resetFiltersOrdersForDocuments();
    this.props.getAllOrdersForDocuments();
  };

  toggleSaveCurrentFilter = () => {
    this.setState(() => ({
      visibleSuccessSaveFilter: !this.state.visibleSuccessSaveFilter,
    }));
  };

  toggleAcceptCurrentFilter = () => {
    this.setState(() => ({
      visibleAcceptSaveFilter: !this.state.visibleAcceptSaveFilter,
    }));
  };

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e),
      },
    }));
  };

  toggleVisibleMap = () => {
    const visibleMap = this.state.visibleMap;

    this.setState(() => ({
      visibleMap: !visibleMap,
    }));
  };

  onChangeTable = (pagination, filters) => {
    /* todo взять пример из сотрудников
    this.setState(() => ({
      filter: filters,
    }));*/
  };

  onChangeTypeList = e => {
    let statusOrder = e.target.value;
    this.props.changeTypeListDocuments(statusOrder);
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.props.searchOrdersForDocuments(value);
  };

  onColsChange = e => {
    const { drawerCols } = this.state;
    const newDrawerCols = {
      ...drawerCols,
      [e.target.name]: e.target.checked,
    };
    const tableColumnsLen = this.getTableColumnsLen(newDrawerCols);
    this.setState({
      drawerCols: newDrawerCols,
      tableColumnsLen,
    });
  };

  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };

  showDrawer = () => {
    this.setState({
      isDrawerVisible: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerVisible: false,
    });
  };

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];
    let cols = [
      {
        title: 'Номер заказа',
        title_full: 'Номер заказа (Наименование)',
        dataIndex: 'info',
        key: 'info',
        render: info => (
          <span>
            <Text>
              {/* todo убрать регулярки  */}
              {info.offerNumber &&
                info.offerNumber.replace(/\W/gi, '').replace(/(.{3})/g, '$1 ')}
            </Text>
            <br />
            {info.change ? (
              <Text>
                Изменен: {moment(parseInt(info.change)).format('DD.MM.YYYY')}
              </Text>
            ) : info.create ? (
              <Text type="secondary">
                Создан: {moment(parseInt(info.create)).format('DD.MM.YYYY')}
              </Text>
            ) : null}
          </span>
        ),
        sorter: (a, b) => {
          return (
            a.info.offerNumber &&
            a.info.offerNumber.localeCompare(b.info.offerNumber)
          );
        },
      },
      {
        title: 'Вид',
        title_full: 'Вид транспортной услуги',
        dataIndex: 'view',
        key: 'view',
        render: view => (
          <span>
            <Text style={{ textTransform: 'uppercase' }}>{view.abbr}</Text>
            <br />
            <Text style={{ color: view.color }}>{view.description}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return (
            a.view.id && String(a.view.id).localeCompare(String(b.view.id))
          );
        },
      },
      {
        title: 'Статус',
        title_full: 'Статус заказа',
        dataIndex: 'state',
        key: 'state',
        render: state => (
          <span>
            <Text>
              {state.status === 'Выполняется' && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: '#00a8ff',
                    marginRight: 8,
                    marginTop: 3,
                  }}
                />
              )}
              {state.status === 'Бронь' && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: '#9b9b9b',
                    marginRight: 8,
                    marginTop: 3,
                  }}
                />
              )}
              {state.status === 'Готов к выполнению' && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: '#97dc76',
                    marginRight: 8,
                    marginTop: 3,
                  }}
                />
              )}
              {state.status === 'Назначение' && (
                <Badge
                  dot={true}
                  style={{
                    backgroundColor: '#d9d9d9',
                    marginRight: 8,
                    marginTop: 3,
                  }}
                />
              )}
              {state.status}
            </Text>
            <br />
            <Text type="secondary" style={{ color: state.color }}>
              {state.description}
            </Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.state.status && a.state.status.localeCompare(b.state.status);
        },
      },
      {
        title: 'Пасс.',
        title_full: 'Количество пассажиров',
        dataIndex: 'passengers',
        key: 'passengers',
        render: passengers => (
          <span>{passengers === '0' ? '—' : passengers}</span>
        ),
        sorter: (a, b) => {
          return (
            a.passengers &&
            a.passengers.localeCompare(b.passengers, 'en-US', {
              numeric: 'true',
            })
          );
        },
      },
      {
        title: 'Документы',
        dataIndex: 'documents',
        key: 'documents',
        render: documents => (
          <span>
            {documents.allDocumentsCount && (
              <Text>{documents.allDocumentsCount}</Text>
            )}
            {documents.missingDocumentsCount > 0 ? (
              ` (не готово: ${documents.missingDocumentsCount})`
            ) : (
              <React.Fragment>
                <br />
                <Text style={{ fontWeight: 'bold' }}>Документы готовы</Text>
              </React.Fragment>
            )}
          </span>
        ),
      },
      {
        title: 'Цена',
        title_full: '',
        dataIndex: 'price',
        key: 'price',
        render: price => (
          <span>
            {price.total ? (
              <Text>{getNumberWithoutSpaces(price.total)} ₽</Text>
            ) : null}
            <br />
            {price.balance ? (
              price.balance === price.total ? (
                <Text>Оплачен</Text>
              ) : (
                <Text type="secondary">
                  {getNumberWithoutSpaces(price.balance)} ₽
                </Text>
              )
            ) : null}
          </span>
        ),
        sorter: (a, b) => {
          return a.price.total && a.price.total - b.price.total;
        },
      },
      {
        title: 'Длина',
        title_full: 'Длина маршрута',
        dataIndex: 'routeLength',
        key: 'routeLength',
        render: routeLength =>
          routeLength ? (
            <span>
              <Text>{getNumberWithoutSpaces(routeLength)} км</Text>
            </span>
          ) : null,
        sorter: (a, b) => {
          return a.routeLength && a.routeLength - b.routeLength;
        },
      },
      {
        title: 'Дата подачи',
        title_full: '',
        dataIndex: 'dateApplication',
        key: 'dateApplication',
        render: dateApplication =>
          dateApplication ? (
            <span>
              {moment(dateApplication).format('DD.MM.YYYY HH:mm')}
              <br />
              <Text type="secondary">{moment(dateApplication).fromNow()}</Text>
            </span>
          ) : null,
        sorter: (a, b) => {
          return (
            a.dateApplication &&
            a.dateApplication.localeCompare(b.dateApplication)
          );
        },
      },
      {
        title: 'Место подачи',
        title_full: '',
        dataIndex: 'placeDelivery',
        key: 'placeDelivery',
        render: placeDelivery => (
          <span style={{ whiteSpace: 'normal' }}>
            <Text>{placeDelivery.address}</Text>
            <br />
            <Text type="secondary">{placeDelivery.city}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.placeDelivery.city.localeCompare(b.placeDelivery.city);
        },
      },
      {
        title: 'Форма расчетов',
        title_full: '',
        dataIndex: 'settlementForm',
        key: 'settlementForm',
        render: settlementForm => (
          <span>
            <Text>{settlementForm.description}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return (
            a.settlementForm.id && a.settlementForm.id - b.settlementForm.id
          );
        },
      },
      {
        title: 'Водитель',
        title_full: '',
        dataIndex: 'driver',
        key: 'driver',
        render: driver =>
          driver && driver.length > 0
            ? driver.map(item => <div key={item.id}>{item.userName}</div>)
            : '',
      },
      {
        title: 'Конечный пункт',
        title_full: '',
        dataIndex: 'finalDestination',
        key: 'finalDestination',
        render: finalDestination => (
          <span>
            <Text>{finalDestination.address}</Text>
            <br />
            <Text type="secondary">{finalDestination.city}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.finalDestination.city.localeCompare(b.finalDestination.city);
        },
      },
      {
        title: 'Дата создания',
        title_full: '',
        dataIndex: 'info',
        key: 'dateCreation',
        render: info =>
          info.create ? (
            <span>
              {moment(info.create).format('DD.MM.YYYY HH:mm')}
              <br />
              <Text type="secondary">{moment(info.create).fromNow()}</Text>
            </span>
          ) : null,
        sorter: (a, b) => {
          return a.info.create && a.info.create.localeCompare(b.info.create);
        },
      },
      {
        title: 'Статус отправки в АЦБПДП',
        title_full: '',
        dataIndex: 'statusSendingACBDP',
        key: 'statusSendingACBDP',
      },
      {
        title: 'Отправка в ГИБДД',
        title_full: '',
        dataIndex: 'sendingTrafficPolice',
        key: 'sendingTrafficPolice',
      },
    ];

    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        this.props.history.push('/' + URLs.DOCUMENT_BY_ORDERS + '/' + row.id);
      },
    };
  };

  onChangeRowSelection = row => {
    console.log(row);
  };

  handleFiltersChange = values => {
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key]) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    this.props.updateFilterFieldsOrdersForDocuments(val);
  };

  render() {
    const {
      isDrawerVisible,
      drawerCols,
      filter,
      pagination,
      showFilterAll,
      orders,
      markers,
    } = this.state;
    return (
      <div className="orders">
        <ConfigTableColumns
          columns={drawerCols}
          visible={isDrawerVisible}
          close={this.closeDrawer}
          changed={this.onColsChange}
        />
        <div className="orders__content">
          <TopPanel
            typesList={this.props.documentTypes}
            stat={this.props.ordersStat}
            totalDocuments={this.props.orders && this.props.orders.length}
            onChangeTypeList={this.onChangeTypeList}
            onChangeSearch={this.onChangeSearch}
          />
          <div className="orders__filters">
            <FiltersInfoPanel
              visibleSuccessSaveFilter={this.state.visibleSuccessSaveFilter}
              visibleAcceptSaveFilter={this.state.visibleAcceptSaveFilter}
              visibleMap={this.state.visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              resetFilters={this.resetFilters}
              toggleAcceptCurrentFilter={this.toggleAcceptCurrentFilter}
              toggleSaveCurrentFilter={this.toggleSaveCurrentFilter}
            />
            <Filters
              showFilterAll={showFilterAll}
              filter={filter}
              showDrawer={this.showDrawer}
              toggleAllFilter={this.toggleAllFilter}
              handleFiltersChange={this.handleFiltersChange}
            />
            {this.state.visibleMap && <PlacemarkMap markers={markers} />}
          </div>
          <OrdersTable
            renderColumns={this.renderColumns}
            tableColumnsLen={this.state.tableColumnsLen}
            orders={orders}
            pages={pagination.pages}
            ordersLoading={this.props.ordersLoading}
            changePaginationSize={this.changePaginationSize}
            onChangeTable={this.onChangeTable}
            handleClickRow={this.handleClickRow}
            onChangeRowSelection={this.onChangeRowSelection}
            watchedRecords={false}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const { documents, filters } = state.Documents;
    return {
      ordersLoading: documents.documentsLoading,
      orders: filters.count > 0 ? documents.filterOrders : documents.allOrders,
      ordersStat:
        filters.count > 0
          ? documents.filterOrdersStat
          : documents.allOrdersStat,
      documentTypes: documents.documentTypes,
      filters,
    };
  },
  {
    getAllOrdersForDocuments,
    //  Filters
    updateFilterFieldsOrdersForDocuments,
    searchOrdersForDocuments,
    changeTypeListDocuments,
    resetFiltersOrdersForDocuments,
  }
)(Documents);
